module.exports = __webpack_public_path__ + "media/images/ui__textArrowLeft--dark-23b00f99707b17df0d5a7d6316d667e0.png";